import { all, call, put, takeLatest, select } from 'redux-saga/effects';

import { request } from '@app/services';
import * as endpoints from './endpoints';
import {
  addClient,
  addClientSuccess,
  addClientFailed,
  getClients,
  getClientsFailed,
  getClientsSuccess,
  updateClient,
  updateClientSuccess,
  updateClientFailed,
  updateClientStatus,
  updateClientStatusFailed,
  updateClientStatusSuccess,
  getClientDetails,
  getClientDetailsFailed,
  getClientDetailsSuccess,
  getClientDetailsByIdSuccess,
  getClientDetailsByIdFailed,
  getClientDetailsById,
} from './slice';
import { RootState } from '@app/redux/root-reducer';

function* addClientSagas(action: ReturnType<typeof addClient>): any {
  try {
    const { firstName, lastName, email, phone, companyName, clientImage } = action.payload;
    const formData = new FormData();
    formData.append('firstName', firstName);
    formData.append('lastName', lastName);
    formData.append('email', email);
    formData.append('phone', phone);
    formData.append('companyName', companyName);
    formData.append('image', clientImage);
    const result = yield call(request.post, endpoints.addClient, formData);
    yield put(addClientSuccess(result.data));
  } catch (err) {
    yield put(addClientFailed(err));
  }
}
//
function* getClientSagas(action: ReturnType<typeof getClients>): any {
  try {
    const result = yield call(request.get, endpoints.getClients);
    yield put(getClientsSuccess(result.data));
  } catch (err) {
    yield put(getClientsFailed(err));
  }
}
function* updateClientSaga(action: ReturnType<typeof updateClient>): any {
  try {
    const { id, firstName, lastName, phone, email, companyName, clientImage } = action.payload;
    const formData = new FormData();
    formData.append('firstName', firstName);
    formData.append('lastName', lastName);
    formData.append('email', email);
    formData.append('phone', phone);
    formData.append('companyName', companyName);
    formData.append('image', clientImage);
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const result = yield call(request.put, `${endpoints.updateClient}${id}`, formData);
    yield put(updateClientSuccess(result.data.data));
    yield put(getClientDetailsById(id));
  } catch (err) {
    yield put(updateClientFailed(err));
  }
}
function* updateClientStatusSaga(action: ReturnType<typeof updateClientStatus>): any {
  try {
    const { row } = action.payload;
    const { data } = yield select((store: RootState) => store.clientsReducer.clients);
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const result = yield call(request.put, `${endpoints.updateClientStatus}${row.id}`, {
      status: !row.status,
    });
    yield put(updateClientStatusSuccess(result.data));
    const updatedClients = data?.map((client: { id: number; status: boolean }) => {
      if (client.id === row.id) {
        return {
          ...client,
          status: !client.status,
        };
      }
      return client;
    });
    yield put(getClientsSuccess(updatedClients));
  } catch (err) {
    yield put(updateClientStatusFailed(err));
  }
}
function* getClientDetailsSaga(action: ReturnType<typeof getClientDetails>): any {
  try {
    const clientId = action.payload;
    // eslint-disable-next-line @typescript-eslint/no-base-to-string, @typescript-eslint/restrict-template-expressions
    const result = yield call(request.get, `${endpoints.getClientDetails}${clientId}`);
    yield put(getClientDetailsSuccess(result.data.projects));
  } catch (err) {
    yield put(getClientDetailsFailed(err));
  }
}
//
function* getClientDetailsByIdSaga(action: ReturnType<typeof getClientDetailsById>): any {
  try {
    const clientId = action.payload;
    // eslint-disable-next-line @typescript-eslint/no-base-to-string, @typescript-eslint/restrict-template-expressions
    const result = yield call(request.get, `${endpoints.getClientDetailsById}${clientId}`);
    yield put(getClientDetailsByIdSuccess(result.data));
  } catch (err) {
    yield put(getClientDetailsByIdFailed(err));
  }
}
function* clientsSagas() {
  yield all([
    takeLatest([getClients, addClientSuccess, updateClientSuccess], getClientSagas),
    takeLatest(addClient, addClientSagas),
    takeLatest(updateClient, updateClientSaga),
    takeLatest(updateClientStatus, updateClientStatusSaga),
    takeLatest(getClientDetails, getClientDetailsSaga),
    takeLatest(getClientDetailsById, getClientDetailsByIdSaga),
  ]);
}
export { clientsSagas };
